import { render, staticRenderFns } from "./TablaPresupuestos.vue?vue&type=template&id=2617a286"
import script from "./TablaPresupuestos.vue?vue&type=script&lang=js"
export * from "./TablaPresupuestos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports